export const loadImages = async (urls) => {
  for (let i = 0; i < urls.length; i += 6) {
    const batch = urls.slice(i, i + 6);

    // Ждем загрузки всей пачки
    await Promise.all(
      batch.map((url) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            resolve();
          };
          img.onerror = resolve;
          img.src = url;
        });
      })
    );

    // Пауза между пачками
    await new Promise((resolve) => setTimeout(resolve, 50));
  }
};

export const loadVideos = async (urls) => {
  for (let i = 0; i < urls.length; i += 6) {
    const batch = urls.slice(i, i + 6);

    // Ждем загрузки всей пачки
    await Promise.all(
      batch.map((url) => {
        return new Promise((resolve) => {
          const video = document.createElement('video');

          video.addEventListener('loadeddata', () => {
            resolve();
          });

          video.addEventListener('error', () => {
            resolve();
          });

          video.preload = 'auto';
          video.src = url;
        });
      })
    );

    // Пауза между пачками
    await new Promise((resolve) => setTimeout(resolve, 50));
  }
};
